
<nav class="subpage-wrapper" >
  <ng-container *ngFor="let subPage of subPages">
    <app-route-link class="main-route-link" [route]="subPage" [queryParams$]="{ podstranka: subPage.url }"  ></app-route-link>
  </ng-container>
</nav>